import { useEffect, useState } from 'react';
import { Box, Button, Checkbox, Chip, FormControl, InputLabel, ListItemText, MenuItem, OutlinedInput, Select, SelectChangeEvent } from '@mui/material';

interface Props {
    idPrefix: string; years: number[]; activeSchoolYear: number | null;
    onApply: (years: number[]) => void; children?: React.ReactNode; grow?: boolean;
    availableYears?: number[];
}

export const DashboardYearFilter = ({ idPrefix, years, activeSchoolYear, onApply, children, grow = false, availableYears }: Props) => {
    const [pendingYears, setPendingYears] = useState(years);
    useEffect(() => setPendingYears(years), [years]);
    const currentYear = activeSchoolYear || new Date().getFullYear();
    const options = availableYears?.length
        ? availableYears
        : Array.from({ length: 6 }, (_, index) => currentYear - index);
    const changed = JSON.stringify(pendingYears) !== JSON.stringify(years);

    const handleChange = (event: SelectChangeEvent<number[]>) => {
        const value = event.target.value;
        setPendingYears(typeof value === 'string' ? value.split(',').map(Number) : value);
    };

    return <Box sx={{
        display: 'flex',
        columnGap: 1,
        rowGap: 2,
        alignItems: 'center',
        flexWrap: 'wrap',
        mb: 2,
    }}>
        <FormControl size="small" sx={{
            minWidth: 220,
            flex: grow ? { xs: '1 1 220px', lg: '1 1 calc(50% - 4px)' } : undefined,
            maxWidth: grow ? { lg: 'calc(50% - 4px)' } : undefined,
        }}>
            <InputLabel id={`${idPrefix}-year-label`}>School Year</InputLabel>
            <Select labelId={`${idPrefix}-year-label`} multiple value={pendingYears} onChange={handleChange}
                input={<OutlinedInput label="School Year" />}
                renderValue={selected => <Box sx={{ display: 'flex', gap: .5, flexWrap: 'wrap' }}>
                    {selected.map(year => <Chip key={year} label={`${year}-${year + 1}`} size="small" />)}
                </Box>}>
                {options.map(year => <MenuItem key={year} value={year}>
                    <Checkbox checked={pendingYears.includes(year)} /><ListItemText primary={`${year}-${year + 1}`} />
                </MenuItem>)}
            </Select>
        </FormControl>
        {children}
        {changed && <Button size="small" variant="contained" onClick={() => onApply(pendingYears)}>Apply</Button>}
    </Box>;
};
